module.exports = __webpack_public_path__ + "img/oil_spills_birds_splash.daccb418.jpg";